import { render, staticRenderFns } from "./GroupContainer.vue?vue&type=template&id=a44fc00c&scoped=true"
import script from "./GroupContainer.vue?vue&type=script&lang=js"
export * from "./GroupContainer.vue?vue&type=script&lang=js"
import style0 from "./GroupContainer.vue?vue&type=style&index=0&id=a44fc00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44fc00c",
  null
  
)

export default component.exports